exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lang {\n  color: white !important;\n  cursor: pointer; }\n\n.lang:hover {\n  color: gray !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/+web/modules/navbar/navbar.component.scss
// module id = 1114
// module chunks = 1